import produce from 'immer';

const INITIAL_STATE = {
  allSlides: null,
};

export default function auth(state = INITIAL_STATE, action) {
  return produce(state, draft => {
    switch (action.type) {
      case '@slides/LOAD_SLIDERS': {
        break;
      }
      case '@slides/LOAD_SLIDES_SUCCESS': {
        draft.allSlides = action.payload.slides;
        break;
      }
      default:
    }
  });
}
